import axios from 'axios';
import { userTypes } from './_actionTypes';
import { to, history} from '../_helpers';
import {alertActions} from './';

const fetchUser = () => async dispatch => {
    const res = await axios.get('/api/users/me');
    dispatch({ type: userTypes.FETCH_USER, payload: res.data });
};

const editUser = (firstName, lastName, email, password = undefined, sendEmails) => async dispatch => {
    const [err, res] = await to(axios.put('/api/users',
        {firstName, lastName, email, password, sendEmails},
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    ));

    if(res){
        dispatch({
            type: userTypes.EDIT_USER_SUCCESS,
            payload: res.data
        });
        dispatch(alertActions.success('Changes Saved!'));
        history.push('/dashboard');
    }else{
        if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.details && err.response.data.error.details[0]){
            dispatch(alertActions.error(err.response.data.error.details[0]));
        }
        dispatch({
            type: userTypes.EDIT_USER_FAILURE,
            payload: err.response
        });
    }
}

export const userActions = {
    fetchUser, editUser
};


// WEBPACK FOOTER //
// ./src/actions/user.actions.js